import React from 'react';
import { TvLocationResponse } from 'entities/TvRender/interfaces';

type Props = {
  data: TvLocationResponse;
  tbody?: string[];
  isDontHaveLp?: boolean;
};

const TvTable: React.FC<Props> = ({ data, isDontHaveLp }) => (
  <div className="tv-table-col w-100">
    <h2 className="text-uppercase">{isDontHaveLp ? 'Оновлення данних' : data.locationName}</h2>

    <div className="tv-grid">
      {data &&
        data.licensePlates &&
        data.licensePlates.length > 0 &&
        data.licensePlates.slice(0, 8).map((tb, index) => (
          <div key={index} className="tv-plate">
            {tb}
          </div>
        ))}
    </div>
  </div>
);

export default TvTable;
